import { render, staticRenderFns } from "./TabModalCompanyDetai.vue?vue&type=template&id=04a033c6"
import script from "./TabModalCompanyDetai.vue?vue&type=script&lang=js"
export * from "./TabModalCompanyDetai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports